import { useI18n } from "./i18n/I18nContext.jsx";
import { LOCALE_LABELS, SUPPORTED_LOCALES } from "./i18n/locales.js";

// Compact <select> language picker, styled to sit next to ThemeToggle in the
// header (see PublicPage.jsx). Persists the choice via I18nProvider, which
// writes it to localStorage. Non-English options currently render English
// content (see i18n/messages/ — only en.json exists so far) but are listed
// now so real catalogs can be dropped in later without a UI change.
export default function LanguageSwitcher({ className }) {
  const { locale, t, setLocale } = useI18n();
  return (
    <select
      aria-label={t("common.language")}
      value={locale}
      onChange={(e) => setLocale(e.target.value)}
      className={className ?? "language-switch"}
    >
      {SUPPORTED_LOCALES.map((code) => (
        <option key={code} value={code}>
          {LOCALE_LABELS[code]}
        </option>
      ))}
    </select>
  );
}
